/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-nested-ternary */
import React, { FC } from 'react'
import { ListItemText, ListItemIcon, ListItem } from '@material-ui/core'
import { FaRegCircle, FaCheckCircle, FaRegTimesCircle } from 'react-icons/fa'
import './styles.scss'

interface Props {
  handleClick: () => void
  title: string
  status: boolean
  isInvalid?: boolean
  disableType?: string
}

const MavCircleCheckBox: FC<Props> = ({
  status,
  title,
  handleClick,
  isInvalid,
  disableType = '',
}) => {
  return (
    <ListItem
      button
      className="mav-circle-checkbox"
      onClick={() => (isInvalid ? {} : handleClick())}
    >
      <ListItemIcon>
        {status ? (
          <FaCheckCircle className="check_icon" />
        ) : disableType === 'times' ? (
          <FaRegTimesCircle className="red" />
        ) : (
          <FaRegCircle />
        )}
      </ListItemIcon>
      <ListItemText primary={title} />
    </ListItem>
  )
}

export default MavCircleCheckBox
